import React from 'react';
import styled from 'styled-components/macro';
import mappings from './thirdPartyTracking/mappings';

function facebook(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
}

if (typeof window !== 'undefined')
    facebook(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
    );

const pixels = [];
let useThirdPartyFBTracking = false;

export const initializePixels = (pixelIds, widgetId) => {
    useThirdPartyFBTracking = mappings.findIndex(mapping =>
        mapping.widgetIds.includes(widgetId) &&
        mapping.useThirdPartyFBTracking
    ) > -1;

    if (mappings.findIndex(mapping =>
        mapping.widgetIds.includes(widgetId) &&
        mapping.dontAutoInitFBPixel) > -1) return;

    pixelIds.forEach(id => {
        if (typeof window !== 'undefined') {
            window.fbq('init', id);
            if (!useThirdPartyFBTracking && pixels.indexOf(id) === -1) {
                pixels.push(id);
            }
        }
    });
};

export const trackContent = (
    type,
    widgetId,
    actionId,
    questionText,
    answerId,
    answerText
) => {
    if (useThirdPartyFBTracking) return;
    const data = {
        content_type: type,
        content_ids: [widgetId, actionId, answerId],
        content_name: (questionText || '') + ' | ' + (answerText || '')
    };
    window.fbq('track', 'ViewContent', data);
};

export const trackWidgetVisible = (widgetId, articleUrl) => {
    if (useThirdPartyFBTracking) return;
    const data = {
        content_ids: [widgetId, articleUrl]
    };
    window.fbq('track', 'PageView', data);
};

const Pixel = styled.img`
    height: 1px;
    width: 1px;
    display: none;
`;

const Container = styled.div``;

export const FacebookPixel = props => {
    return (
        <Container>
            {pixels.map(id => (
                <Pixel
                    key={id}
                    src={
                        'https://www.facebook.com/tr?id=' + id + '&ev=PageView&noscript=1'
                    }
                />
            ))}
        </Container>
    );
};
